var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 6V7.33333M8.001 10H8.00767M3.3822 12.6667H12.6198C13.6462 12.6667 14.2877 11.5556 13.7745 10.6667L9.1557 2.66667C8.6425 1.77778 7.3595 1.77778 6.8463 2.66667L2.2275 10.6667C1.7143 11.5556 2.3558 12.6667 3.3822 12.6667Z",
    stroke: "#641616",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageError);
export default __webpack_public_path__ + "static/media/storage-error.df1727372adb5c2dec14be761b489564.svg";
export { ForwardRef as ReactComponent };